import * as React from 'react';
import { Helmet } from 'react-helmet';
import { useParams } from 'react-router-dom';
import InsertLinkIcon from '@mui/icons-material/InsertLink';
import VolunteerActivismIcon from '@mui/icons-material/VolunteerActivism';
import PaymentsIcon from '@mui/icons-material/Payments';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import { useStoreActions } from 'easy-peasy';
import { FacebookShareButton, WhatsappShareButton, TwitterShareButton, EmailShareButton } from 'react-share';
import { Get } from '../services/http';
import DonateOptionSelectDialog from '../dialogs/donate-option-select';
import AddPartnerDialog from '../dialogs/add-partner-dialog';
import PartnersListDialog from '../dialogs/partners';
import PayCheckPopup from '../dialogs/pay-check-popup';
import UtmLink from '../dialogs/utm-link';


let bannersList = [];
let numActiveSlide = 0;
let interval;
export default function GeneralCampaign() {
    const [campaign, setCampaigns] = React.useState(null);
    const [optionsAmount, setOptionsAmount] = React.useState(null);
    const openInfoPopup = useStoreActions((actions) => actions.open);
    const [banners, setBanners] = React.useState(null);
    const [activeSlide, setActiveSlide] = React.useState(0);
    const [donateSum, setDonateSum] = React.useState(null);
    const [isDonateSumDialog, setDonateSumDialog] = React.useState(false);
    const [campaignSlug, setCampaignSlug] = React.useState(false);
    const [currency, setCurrency] = React.useState(null);
    const [currencyOpen, setCurrencyOpen] = React.useState(false);
    const [openCheck, setOpenCheck] = React.useState(false);
    const currencyList = ['$', '€'];
    const { campaignID } = useParams();
    const { partnerSlug } = useParams();
    const [campaignFirstDetails, setCampaignFirstDetails] = React.useState(false);
    const hideSpinner = useStoreActions((action) => action.hideSpinner);
    const showSpinner = useStoreActions((action) => action.showSpinner);
    const [isStartSlider, setStartSlider] = React.useState(false);
    const [isStopBlock, setStopBlock] = React.useState(false);

    const slideNext = () => {
        console.log('numActiveSlide', numActiveSlide);
        const sliderCount = bannersList?.length;
        const oldSlide = numActiveSlide;
        let nextSlide = numActiveSlide + 1;
        if (nextSlide >= sliderCount) {
            nextSlide = 0;
        }
        const slidedBanners = bannersList?.map((item, index) => {
            if (nextSlide === index) {
                item.animationClassName = 'active_left';
            } else if (oldSlide === index) {
                item.animationClassName = 'previous_left';
            } else {
                item.animationClassName = '';
            }
            return item;
        });
        setBanners(slidedBanners);
        setActiveSlide(nextSlide);
        numActiveSlide = nextSlide;
    };

    const getCampaignData = async () => {
        const projectData = await Get('/api/donation/GetProjectBySlug', { campaignID });
        hideSpinner();
        if (projectData.result) {
            setCampaigns(projectData.campaign);
            const object = JSON.parse(projectData.campaign.optionsAmountMoney);
            const bannersObject = JSON.parse(projectData.campaign.banners);
            bannersObject?.map((item, index) => {
                if (index === 0) {
                    item.animationClassName = 'active_left';
                } else {
                    item.animationClassName = '';
                }
                return item;
            });
            setBanners(bannersObject);
            setOptionsAmount(object);
            bannersList = bannersObject;
            setCurrency(projectData.campaign.currency);
            console.log('bannersObject GeneralCampaign', bannersObject);
            setCampaignSlug(projectData.campaign.slug);
        }
    };

    const getCampaignFirstDetails = async () => {
        const projectData = await Get('/api/donation/GetCampaignFirstDetails', { campaignID: campaignID });
        setCampaignFirstDetails(projectData);
    };

    const doDonate = () => {
        window.location.href = '/donation-summary/' + campaignSlug + '/0/' + currency;
    };

    const changeDonateSum = (newSum) => {
        if (newSum > 0) {
            setDonateSum(newSum);
            document.getElementById('input-donate-sum').value = newSum;
        } else {
            newSum = document.getElementById('input-donate-sum').value;
            setDonateSum(newSum);
        }
    };

    const slidePrev = () => {
        const sliderCount = bannersList.length;
        const oldSlide = numActiveSlide;
        let nextSlide = numActiveSlide - 1;
        if (nextSlide < 0) {
            nextSlide = (sliderCount - 1);
        }
        const slidedBanners = bannersList.map((item, index) => {
            if (nextSlide === index) {
                item.animationClassName = 'active_right';
            } else if (oldSlide === index) {
                item.animationClassName = 'previous_right';
            } else {
                item.animationClassName = '';
            }
            return item;
        });
        setBanners(slidedBanners);
        setActiveSlide(nextSlide);
        numActiveSlide = nextSlide;
    };
    const toggleCurrency = () => {
        const isOpen = !currencyOpen;
        setCurrencyOpen(isOpen);
    };
    const setCurrencyValue = (newCurrency) => {
        setCurrency(newCurrency);
        setCurrencyOpen(false);
    };
    const setCookie = (name, value, days) => {
        let expires = '';
        if (days) {
            const date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = '; expires=' + date.toUTCString();
        }
        document.cookie = name + '=' + (value || '') + expires + '; path=/';
    };
    const setPartner = (newPartnerSlug) => {
        setCookie('newPartnerSlug', newPartnerSlug, 386);
    };

    const startSlider = () => {
        setStartSlider(true);
        console.log('startSlider');
        interval = setInterval(() => {
            slideNext();
            console.log('slideNext');
        }, 5000);
    };

    const stopSlider = () => {
        console.log('stopSlider');
        setStopBlock(true);
        clearInterval(interval);
    };

    React.useEffect(() => {
        showSpinner();
        getCampaignFirstDetails();
        getCampaignData();
        if (partnerSlug !== null) {
            console.log('partnerSlug', partnerSlug);
            setPartner(partnerSlug);
        }
        console.log('campaign', campaign);
        if (isStartSlider === false) {
            startSlider();
        }
    }, [campaignSlug]);

    return (
        <>
            <Helmet>
                <title>World of Tzedaka - Campaign</title>
            </Helmet>
            {openCheck ? (
                <PayCheckPopup campaignName={campaign?.name} campaignID={campaignID} closePopup={setOpenCheck} isOpen />
            ) : ''}
            <main className="main general-campaign">
                {campaign?.mainImage === null ? (
                    <div class="banner" style={{ backgroundImage: 'url(/img/pop.png)' }}></div>
                ) : (
                    <div class="banner" style={{ backgroundImage: 'url(' + campaignFirstDetails?.mainImage + ')' }}></div>
                )}
                <section className="promo bg-color">
                    <div className="container">
                        <div className="bg-color" style={{ marginTop: '-100px', paddingTop: '10px', paddingBottom: '10px', paddingRight: '30px', paddingLeft: '30px' }}>
                            <p style={{ marginBottom: '10px', textAlign: 'start', color: 'black' }} className="font-small bold">Main {'>>'} <span style={{ color: '#088fdd' }}>General Donation</span></p>
                            <h3 style={{ textTransform: 'uppercase', textAlign: 'start', color: 'black' }}>{campaignFirstDetails?.name}</h3>
                            <hr />
                            <div className="f-16" style={{ color: 'black', textAlign: 'justify' }}>{campaign?.shortText}</div>
                        </div>
                        <div className="promo__social social">
                            <WhatsappShareButton url={window.location.href} title={campaign?.name + ': '}>
                                <a href="#" class="social__link social__link--whatsapp">
                                    <img src="/img/sprite/whatsapp.svg" alt="" />
                                </a>
                            </WhatsappShareButton>
                            <TwitterShareButton url={window.location.href} title={campaign?.name + ': '}>
                                <a href="#" class="social__link social__link--twitter">
                                    <img src="/img/sprite/twitter.svg" alt="" />
                                </a>
                            </TwitterShareButton>
                            <FacebookShareButton url={window.location.href} quote={campaign?.name}>
                                <a href="#" class="social__link social__link--facebook">
                                    <img src="/img/sprite/facebook.svg" alt="" />
                                </a>
                            </FacebookShareButton>
                            <EmailShareButton url={window.location.href} subject={campaign?.name}>
                                <a href="#" class="social__link social__link--mail">
                                    <img src="/img/sprite/mail.svg" alt="" />
                                </a>
                            </EmailShareButton>
                            <UtmLink />

                        </div>
                        {bannersList?.length > 0 ? (
                            <div className="slider">
                                <div className="slider__wrapper">
                                    {isStopBlock === false ? (<div className="slider_stop_block" onClick={stopSlider}></div>) : ''}
                                    {bannersList?.map((bannersItem, index) => (
                                        bannersItem?.type === 'image' ? (
                                            <div className={'slider__item ' + bannersItem.animationClassName}>
                                                <div className="video" style={{ 'background-image': 'url(' + bannersItem?.url + ')' }}>
                                                </div>
                                            </div>
                                        ) : (
                                            <div className={'slider__item ' + bannersItem.animationClassName}>
                                                <div className="video">
                                                    <iframe width="100%" height="auto" src={bannersItem?.code} title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                                                </div>
                                            </div>
                                        )
                                    ))}
                                </div>
                                <div className="slider__prev" onClick={slidePrev}>
                                    <img src="/img/sprite/arrow-left.svg" alt="" />
                                </div>
                                <div className="slider__next" onClick={slideNext}>
                                    <img src="/img/sprite/arrow-left.svg" alt="" />
                                </div>
                                <div className="slider__dots">
                                    {bannersList?.map((bannersItem, index) => (<div className={activeSlide === index ? 'slider__bullet _active' : 'slider__bullet'}></div>))}
                                </div>
                            </div>
                        ) : ''}

                        <div className="">
                            <div className="_anim-items  _fadeLeft">
                            {campaign != null ? (
                                <div className="text-center" style={{ marginTop: '40px', marginBottom: '80px' }}>
                                    <a class onClick={doDonate} 
                                    style={{ cursor: 'pointer',
                                    fontSize:'22px',
                                    fontFamily:'Rubik',

                                     textDecoration: 'none', fontWeight: '700', paddingLeft: '120px', paddingRight: '120px', paddingTop: '15px', paddingBottom: '15px' }} 
                                    className="login_button"> <span> 
                                    <img src="/img/sprite/hearthand.png" width="35px" />  
                                    {/* <img src="/img/sprite/usr.png" alt="" width="15px" /> */}
                                    </span>  DONATE</a>
                                    <div style={{ marginTop: '30px' }}>
                                        <PayCheckPopup campaignName={campaign?.name} />
                                    </div>
                                </div>
                            ) : ''}
                            </div>
                            <div className="koach__right _anim-items  _fadeRight">
                                {campaign?.isHatzedakaCertificate === true ? (
                                    <div class="rabanim-wrapper">
                                        <div class="rabanim-text">
                                            THIS CAUSE HAS BEEN VERIFIED<br />
                                            BY THE VA’AD HATZEDAKAH - <br />
                                            TOMCHEI TZEDEKAH OF LAKEWOOD
                                        </div>
                                        <div class="rabanim-account">Certification/Account <span># {campaign?.hatzedakaCertificateNumber} </span></div>
                                    </div>
                                ) : ''}
                            </div>
                        </div>
                        <div class="post-content">
                            <div className="promo__context">
                                <p>
                                    <span className="font-600" dangerouslySetInnerHTML={{ __html: campaign?.text }} />
                                </p>
                            </div>
                        </div>
                    </div>
                </section>

                {/*   <section className="send section">
                    <div className="container">
                        <div className="section__head">
                            <h2 className="section__title section__title--info _anim-items  _fadeScale" data-animate-delay="02"><span>Send us a message</span></h2>
                            <h3 className="section__subtitle _anim-items  _fadeUp" data-animate-delay="03">For campaign: KOACH</h3>
                        </div>
                        <div className="send-form _anim-items  _fadeUp" data-animate-delay="04">
                            <div className="send-form__item">
                                <input type="text" className="form-input" placeholder="Name:" />
                            </div>
                            <div className="send-form__item">
                                <input type="text" className="form-input" placeholder="Email:" />
                            </div>
                            <div className="send-form__item">
                                <input type="text" className="form-input" placeholder="tel:" />
                            </div>
                            <div className="send-form__message">
                                <textarea className="form-input" placeholder="Massage:"></textarea>
                            </div>
                            <div className="send-form__button">
                                <button type="submit" className="form-btn form-btn--block">SEND</button>
                            </div>

                        </div>
                    </div>
                </section> */}
                {campaign != null ? (
                    <div class="donate-fixed">
                        <div class="container">
                            <div class="donate-fixed__inner" >
                                <a href="#" class="donate-fixed__button" onClick={doDonate}>
                                    Donate Now!
                                    <img src="/img/sprite/wallet.svg" alt="" />
                                </a>
                                <div class="donate-fixed__social social">
                                    <WhatsappShareButton url={window.location.href} title={campaign?.name + ': '}>
                                        <a href="#" class="social__link social__link--whatsapp">
                                            <img src="/img/sprite/whatsapp.svg" alt="" />
                                        </a>
                                    </WhatsappShareButton>
                                    <TwitterShareButton url={window.location.href} title={campaign?.name + ': '}>
                                        <a href="#" class="social__link social__link--twitter">
                                            <img src="/img/sprite/twitter.svg" alt="" />
                                        </a>
                                    </TwitterShareButton>
                                    <FacebookShareButton url={window.location.href} quote={campaign?.name}>
                                        <a href="#" class="social__link social__link--facebook">
                                            <img src="/img/sprite/facebook.svg" alt="" />
                                        </a>
                                    </FacebookShareButton>
                                    <EmailShareButton url={window.location.href} subject={campaign?.name}>
                                        <a href="#" class="social__link social__link--mail">
                                            <img src="/img/sprite/mail.svg" alt="" />
                                        </a>
                                    </EmailShareButton>
                                </div>
                            </div>
                        </div>
                    </div>
                ) : ''}
            </main>
        </>
    );
}
